<div  class="pages-result__img-col">
	<div class="pages-result__icon">
		<span class="icon-file-pdf"></span>
	</div>
</div>
